import { useEffect, useState } from "react";

export function usePWAInstall() {
  const [installPrompt, setInstallPrompt] = useState(null);
  const [isIOSUser, setIsIOSUser] = useState(false);
  const [isAndroidUser, setIsAndroidUser] = useState(false);
  const [showAndroidPrompt, setShowAndroidPrompt] = useState(false);
  const [isInstalled, setIsInstalled] = useState(false);

  useEffect(() => {
    // Detect platform
    const userAgent = navigator.userAgent.toLowerCase();
    const isIOS = /iphone|ipad|ipod/.test(userAgent) && !window.MSStream;
    const isAndroid = /android/.test(userAgent);
    const isInStandaloneMode = window.navigator.standalone === true;

    setIsIOSUser(isIOS);
    setIsAndroidUser(isAndroid);
    setIsInstalled(isInStandaloneMode);

    // Android: Listen for beforeinstallprompt event
    const handleBeforeInstallPrompt = (e) => {
      e.preventDefault();
      setInstallPrompt(e);
      // Show Android prompt after 3 seconds of user interaction
      setTimeout(() => {
        if (!isInstalled) {
          setShowAndroidPrompt(true);
        }
      }, 3000);
    };

    // Check if app is already installed (via display-mode: standalone)
    const handleAppInstalled = () => {
      setIsInstalled(true);
      setShowAndroidPrompt(false);
    };

    window.addEventListener("beforeinstallprompt", handleBeforeInstallPrompt);
    window.addEventListener("appinstalled", handleAppInstalled);

    // Check if running in standalone mode at load
    if (isInStandaloneMode) {
      setIsInstalled(true);
    }

    return () => {
      window.removeEventListener(
        "beforeinstallprompt",
        handleBeforeInstallPrompt,
      );
      window.removeEventListener("appinstalled", handleAppInstalled);
    };
  }, []);

  const installApp = async () => {
    if (!installPrompt) return;

    try {
      await installPrompt.prompt();
      const { outcome } = await installPrompt.userChoice;

      if (outcome === "accepted") {
        setIsInstalled(true);
        setShowAndroidPrompt(false);
      }

      setInstallPrompt(null);
    } catch (error) {
      console.error("PWA install error:", error);
    }
  };

  const dismissAndroidPrompt = () => {
    setShowAndroidPrompt(false);
  };

  return {
    isIOSUser,
    isAndroidUser,
    showAndroidPrompt,
    isInstalled,
    installApp,
    dismissAndroidPrompt,
    canInstall: !!installPrompt,
  };
}
